/**
 * Check if the current device is a PC/Desktop (not mobile or tablet)
 * Uses screen width as the primary indicator (matches Tailwind's lg breakpoint)
 */
export function isPC(): boolean {
	if (typeof window === "undefined") return true;

	// Use Tailwind's lg breakpoint (1024px) as the threshold
	return window.innerWidth >= 1024;
}

/**
 * Check if the current device is mobile
 */
export function isMobile(): boolean {
	return !isPC();
}

/**
 * Basic JWT payload parser
 * Decodes the base64 payload of a JWT token
 */
export function parseJwt(token: string) {
	try {
		const base64Url = token.split(".")[1];
		const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split("")
				.map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
				.join(""),
		);

		return JSON.parse(jsonPayload);
	} catch (e) {
		console.error("Failed to parse JWT:", e);
		return null;
	}
}
